addEventListener('click', (e) => {
  console.log(e)
  if(e.target.id != 'filter-button' && e.target.parentElement.id != 'filter-button') return
  
  changeClasses(true)
})

addEventListener('click', (e) => {
  if(e.target.id != 'filter_list_items_contener' && e.target.id != 'filterSubmit') return
  
  changeClasses(false)
  changeDuration()
})

function changeClasses(open){
  console.log(open)
  const chatButton = document.querySelector('#dummy-chat-button-iframe')
  const body = document.querySelector('body')
  const filter = document.querySelector('#filter_list_items_contener')
  const filterList = document.querySelector('#filter_list_items')
  const itemList = document.querySelector('#grid_item_list')
  const collection = document.querySelector('#collection-section')
  const filterClasses = [
    'max-lg:-translate-x-full',
    'max-lg:translate-x-0',
    'max-lg:-z-10',
    'max-lg:z-30',
    'max-lg:filter-item-list-background',
    'max-lg:z-50',
    'max-lg:hidden',
    'max-lg:overflow-y-hidden',
    'max-lg:relative',
    'max-lg:z-0'
  ]

  if(open){
    filterList.classList.remove(filterClasses[0])
    filterList.classList.add(filterClasses[1])

    itemList.classList.add(filterClasses[8])
    itemList.classList.add(filterClasses[9])
    
    filter.classList.remove(filterClasses[2])
    filter.classList.add(filterClasses[3])
    filter.classList.add(filterClasses[4])

    collection.classList.add(filterClasses[5])
    
    body.classList.add(filterClasses[7])
    
    chatButton.classList.add(filterClasses[6])
  }
  else{
    filterList.classList.remove(filterClasses[1])
    filterList.classList.add(filterClasses[0])

    itemList.classList.remove(filterClasses[8])
    itemList.classList.remove(filterClasses[9])
    
    filter.classList.remove(filterClasses[3])
    filter.classList.remove(filterClasses[4])
    filter.classList.add(filterClasses[2])

    setTimeout(() => {
      collection.classList.remove(filterClasses[5])
    }, 500)
    
    body.classList.remove(filterClasses[7])
    
    chatButton.classList.remove(filterClasses[6])
  }
}

function changeDuration(){
  const filter = document.querySelector('#filter_list_items_contener')
  const filterList = document.querySelector('#filter_list_items')
  let className = 'max-lg:td-5'
  
  filter.classList.remove(className)
  filterList.classList.remove(className)
  
  if(innerWidth < 990){
    filter.classList.add(className)
    filterList.classList.add(className)
  }
}

addEventListener('resize', changeDuration)
addEventListener('DOMContentLoaded', changeDuration)